<template>
  <exo-help-dialog title="ΔMLTAN">
    ΔMLTAN must be understood as the MLTAN difference with respect to the chosen
    RAAN phasing reference. See mission description for more details.
  </exo-help-dialog>
</template>

<script>
export default {
  name: 'tooltipTargetDeltaLtan'
}
</script>
